var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { ResponsiveBar } from '@nivo/bar';

import Grid from "./layers/Grid";
import Axes from "./layers/Axes";
import Bars from "./layers/Bars";
import BarsItem from "./layers/BarsItem";

import BarTooltip from "./ChartBarTooltip";

import "./ChartBar.scss";

var ChartBar = (_temp2 = _class = function (_Component) {
    _inherits(ChartBar, _Component);

    function ChartBar() {
        var _temp, _this, _ret;

        _classCallCheck(this, ChartBar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            currentBar: undefined
        }, _this.setCurrentBar = function (bar, event) {
            _this.setState({
                currentBar: bar
            });
        }, _this.getAxisTop = function () {
            return null;
        }, _this.getAxisRight = function () {
            var _this$props = _this.props,
                axisRight = _this$props.axisRight,
                margin = _this$props.margin,
                yFormat = _this$props.yFormat,
                gridYValues = _this$props.gridYValues;


            var tickSize = void 0;

            return _extends({
                format: yFormat,
                tickSize: margin.right || 0,
                tickValues: gridYValues
            }, axisRight);
        }, _this.getAxisBottom = function () {
            var _this$props2 = _this.props,
                axisBottom = _this$props2.axisBottom,
                xTickValues = _this$props2.xTickValues,
                xFormat = _this$props2.xFormat,
                dimension = _this$props2.dimension,
                startDate = _this$props2.startDate,
                endDate = _this$props2.endDate;


            return _extends({
                dimension: dimension,
                startDate: startDate,
                endDate: endDate,
                format: xFormat,
                tickSize: 5,
                tickValues: xTickValues || undefined
            }, axisBottom);
        }, _this.getAxisLeft = function () {
            return null;
        }, _this.renderAxes = function (props) {
            var width = props.width,
                height = props.height,
                innerWidth = props.innerWidth,
                innerHeight = props.innerHeight,
                xScale = props.xScale,
                yScale = props.yScale,
                axisTop = props.axisTop,
                axisRight = props.axisRight,
                axisBottom = props.axisBottom,
                axisLeft = props.axisLeft;


            return React.createElement(Axes, {
                key: 'axes',
                width: width,
                height: height,
                xScale: xScale,
                yScale: yScale,
                top: axisTop,
                right: axisRight,
                bottom: axisBottom,
                left: axisLeft
            });
        }, _this.renderGrid = function (props) {
            var width = props.width,
                height = props.height,
                innerWidth = props.innerWidth,
                innerHeight = props.innerHeight,
                enableGridX = props.enableGridX,
                enableGridY = props.enableGridY,
                xScale = props.xScale,
                yScale = props.yScale,
                gridXValues = props.gridXValues,
                gridYValues = props.gridYValues;


            return React.createElement(Grid, {
                key: 'grid',
                width: width,
                height: height,
                xScale: enableGridX ? xScale : null,
                yScale: enableGridY ? yScale : null,
                xValues: gridXValues,
                yValues: gridYValues
            });
        }, _this.renderBars = function (props) {
            var currentBar = _this.state.currentBar;
            var renderTooltip = props.renderTooltip,
                onTooltip = props.onTooltip;


            return React.createElement(Bars, _extends({}, props, {
                current: currentBar,
                setCurrent: _this.setCurrentBar,
                tooltip: _this.renderTooltip
            }));
        }, _this.getLayers = function () {
            return [_this.renderGrid, _this.renderAxes,
            //            this.renderBars,
            'bars', 'markers', 'legends', 'annotations', 'legends'];
        }, _this.getMargin = function () {
            var _this$props3 = _this.props,
                outerMargin = _this$props3.outerMargin,
                margin = _this$props3.margin;


            if (outerMargin && margin) {

                return {
                    top: outerMargin.top + margin.top,
                    right: outerMargin.right + margin.right,
                    bottom: outerMargin.bottom + margin.bottom,
                    left: outerMargin.left + margin.left
                };
            }

            return margin;
        }, _this.renderTooltip = function (props) {

            if (_this.props.renderTooltip) {
                return _this.props.renderTooltip(props);
            }

            return React.createElement(BarTooltip, _extends({}, _this.props, { bar: props }));
        }, _this.getProps = function () {

            return _extends({}, _this.props, {
                layers: _this.getLayers(),
                axisTop: _this.getAxisTop(),
                axisRight: _this.getAxisRight(),
                axisBottom: _this.getAxisBottom(),
                axisLeft: _this.getAxisLeft(),
                tooltip: _this.renderTooltip,
                barComponent: BarsItem,
                margin: _this.getMargin()
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ChartBar.prototype.render = function render() {
        var props = this.getProps();

        console.log('BAR DATA', props);

        return React.createElement(ResponsiveBar, props);
    };

    return ChartBar;
}(Component), _class.defaultProps = {
    data: [],
    keys: [],
    theme: {},
    groupMode: "grouped",
    padding: 0.1,
    innerPadding: 0,
    margin: {
        top: 0,
        right: 60,
        bottom: 60,
        left: 0
    },
    offset: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    xFormat: "date",
    yFormat: "integer",
    xScale: {
        type: "point"
    },
    yScale: {
        type: "linear",
        stacked: false,
        min: 0,
        max: 'auto'
    },
    gridXValues: 5,
    gridYValues: 5,
    enableGridX: false,
    enableGridY: true,
    enableLabel: false,
    animate: false
}, _temp2);


export default ChartBar;